module.exports = __webpack_public_path__ + "static/media/UniNeueHeavy-Italic.f0fbef5c.ttf";